// Twilio templates can have different types: twilio/text, twilio/quick-reply, twilio/card, etc.
// This helper extracts the body from whichever type is present
export const getTemplateBody = (template: any): string | null => {
    if (!template?.types) return null;

    // Priority order for template types
    const typeKeys = ['twilio/quick-reply', 'twilio/text', 'twilio/card', 'twilio/list-picker'];

    for (const typeKey of typeKeys) {
        if (template.types[typeKey]?.body) {
            return template.types[typeKey].body;
        }
    }

    // Fallback: try any type that has a body
    for (const typeKey of Object.keys(template.types)) {
        if (template.types[typeKey]?.body) {
            return template.types[typeKey].body;
        }
    }

    return null;
};

export const extractTemplateParams = (body: string): string[] => {
    console.log("Extracting template params from body", body);
    const paramRegex = /{{(\d+)}}/g;
    const params: string[] = [];
    let match;
    while ((match = paramRegex.exec(body)) !== null) {
        params.push(match[1]);
    }
    return [...new Set(params)]; // Remove duplicates
};

export const replaceTemplateParams = (body: string, params: Record<string, string>): string => {
    console.log("replaceTemplateParams");
    console.log(body, params);
    if(!params || Object.keys(params).length === 0) return body;
    return body.replace(/{{(\d+)}}/g, (match, p1) => params[p1] || match);
};